module.exports = __webpack_public_path__ + "static/media/19_potolok_2.71_0.78f8ea65.png";